import api from 'api/api'
import { toast } from 'react-toastify'

export const SAVE_TRANSFER_HEADER = "[TRANSFERS] SAVE TRANSFER HEADER"
export const GET_TRANSFERS = "[TRANSFERS] GET TRANSFERS"
export const GET_TRANSFER_BY_ID = "[TRANSFERS] GET TRANSFER BY ID"
export const GET_TRANSFERS_ON_WAY = "[TRANSFERS] GET TRANSFERS ON WAY"
export const FINISH_TRANSFER_REGISTER = "[TRANSFERS] FINISH TRANSFER REGISTER"
export const VOID_TRANSFER = "[TRANSFERS] VOID TRANSFER"
export const ACCEPT_TRANSFER = "[TRANSFERS] ACCEPT TRANSFER"
export const REJECT_TRANSFER = "[TRANSFERS] REJECT TRANSFER"

export function saveTransferHeader(form) {
  const request = api.post(`/transfer/save-header`, form)
  return (dispatch) => {
    dispatch({ type: SAVE_TRANSFER_HEADER, payload: { loading: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_TRANSFER_HEADER, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo guardar el traslado")
      console.log(SAVE_TRANSFER_HEADER, error)
    }).finally(() => {
      dispatch({ type: SAVE_TRANSFER_HEADER, payload: { loading: false, saved: false } })
    })
  }
}

export function getTransfers(filters = { startDate: '', endDate: '', status: 'my-transfers', search: '', pageSize: 10 }) {
  const request = api.get(`/transfers/registers`, { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_TRANSFERS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_TRANSFERS, payload: { ...response.data.data } })
    }).catch((error) => {
      toast.error('Error inesperado. No se pudo obtener los traslados')
      console.log(GET_TRANSFERS, error)
    }).finally(() => {
      dispatch({ type: GET_TRANSFERS, payload: { loading: false } })
    })
  }
}

export function getTransferById(transferId) {
  const request = api.get(`/transfer/${transferId}`)
  return (dispatch) => {
    dispatch({ type: GET_TRANSFER_BY_ID, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: GET_TRANSFER_BY_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo obtener el traslado")
      console.log(GET_TRANSFER_BY_ID, error)
    }).finally(() => {
      dispatch({ type: GET_TRANSFER_BY_ID, payload: { loading: false } })
    })
  }
}

export function getTransfersOnWay() {
  const request = api.get(`/transfers/on-way`)
  return (dispatch) => {
    dispatch({ type: GET_TRANSFERS_ON_WAY, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_TRANSFERS_ON_WAY, payload: { loading: false, data: response.data.data } })
    }).catch((error) => {
      toast.error('Error inesperado. No se pudo obtener los traslados en camino')
      console.log(GET_TRANSFERS_ON_WAY, error)
    }).finally(() => {
      dispatch({ type: GET_TRANSFERS_ON_WAY, payload: { loading: false } })
    })
  }
}

export function finishTransferRegisterById(transferId) {
  const request = api.post(`/transfer/finish-register/${transferId}`)
  return (dispatch) => {
    dispatch({ type: FINISH_TRANSFER_REGISTER, payload: { loading: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: FINISH_TRANSFER_REGISTER, payload: { finished: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo finalizar el registro del traslado")
      console.log(FINISH_TRANSFER_REGISTER, error)
    }).finally(() => {
      dispatch({ type: FINISH_TRANSFER_REGISTER, payload: { loading: false, finished: false } })
    })
  }
}

export function voidTransferAction(transferId) {
  const request = api.delete(`/transfer/void/${transferId}`)
  return (dispatch) => {
    dispatch({ type: VOID_TRANSFER, payload: { voiding_id: transferId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: VOID_TRANSFER, payload: { voided_id: transferId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error(error.response?.data?.message ?? 'No se pudo anular el traslado')
      console.log(VOID_TRANSFER, error)
    }).finally(() => {
      dispatch({ type: VOID_TRANSFER, payload: { voiding_id: transferId } })
    })
  }
}

export function acceptTransfer(transferId) {
  const request = api.post(`/transfer/accept/${transferId}`)
  return (dispatch) => {
    dispatch({ type: ACCEPT_TRANSFER, payload: { accepting_id: transferId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: ACCEPT_TRANSFER, payload: { accepted_id: transferId } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo aceptar el traslado")
      console.log(ACCEPT_TRANSFER, error)
    }).finally(() => {
      dispatch({ type: ACCEPT_TRANSFER, payload: { accepting_id: transferId } })
    })
  }
}

export function rejectTransfer(transferId) {
  const request = api.post(`/transfer/reject/${transferId}`)
  return (dispatch) => {
    dispatch({ type: REJECT_TRANSFER, payload: { rejecting_id: transferId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: REJECT_TRANSFER, payload: { rejected_id: transferId } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo rechazar el traslado")
      console.log(REJECT_TRANSFER, error)
    }).finally(() => {
      dispatch({ type: REJECT_TRANSFER, payload: { rejecting_id: transferId } })
    })
  }
}
